import { apiFetch } from "./client";
import type { components } from "./schema";

export type ActivityPage = components["schemas"]["ActivityPageOut"];
export type ActivityItem = components["schemas"]["ActivityItem"];
export type ActivityTab = "all" | "for_me" | "followed" | "claims";

export function listActivity(tab: ActivityTab, cursor: string | null, limit = 30): Promise<ActivityPage> {
  const params = new URLSearchParams({ tab, limit: String(limit) });
  if (cursor) params.set("cursor", cursor);
  return apiFetch<ActivityPage>(`/activity?${params.toString()}`);
}

export async function markRead(ids: string[] | "all"): Promise<number> {
  const body = await apiFetch<components["schemas"]["UnreadOut"]>("/activity/read", {
    method: "POST",
    json: ids === "all" ? { all: true } : { ids },
  });
  return body.unread_count;
}
